import { store } from '../store/store';
import type { ThemeId } from '../schema/ThemeId';

/**
 * Returns boolean indicating the value of currentThemeId property in the store
 */
export const getThemeId = (): ThemeId => store.themeId;
